import { css } from 'emotion';

export const menu = css`
  min-width: 150px;
  box-sizing: border-box;
  margin: 5px 0;

  ul {
    padding: 0;
    margin: 0;
  }
`;
